/**
 * @typedef {import('./Session.js').default} Session
 * @typedef {import('./types.js').SessionParams} SessionParams
 * @typedef {import('./FontsSessionProvider.js').default} FontsSessionProvider
 */

/**
 * @interface
 */
export default class FontsProvider {
    /**
     * @method createSession
     * @param {Session} session
     * @returns {FontsSessionProvider}
     */

    /**
     * @static
     * @method create
     * @param {SessionParams} params
     * @returns {FontsProvider}
     */
}